import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef, frefToRef} from '../../react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {OEAnalyticsEventDataFlag, OEAnalyticsEventName, OEAnalyticsEventDataParamName} from './oe-analytics-model';
import OEAnalyticsTool from './oe-analytics-tool';

export class OEAnalyticsTracker extends React.Component {

    constructor(props) {
        super(props);

        if(this.props.appComponent) this.props.appComponent.analyticsTracker = this;

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.debugOutputEnabled = false;
        this.eventsEnabled = true;

        this.onHelpViewEntryClicked = this.onHelpViewEntryClicked.bind(this);
    }

    //
    get isAvailable() {
        return OEAnalyticsTool.isAvailable;
    }

    track(eventName, eventData, flags = OEAnalyticsEventDataFlag.def) {
        let target = (flags & OEAnalyticsEventDataFlag.target) ? this.props.target : undefined;
        let version = (flags & OEAnalyticsEventDataFlag.version) ? this.props.version : undefined;

        if(this.debugOutputEnabled) {
            let str = 'OEAnalyticsTracker::track - ' + eventName;
            if(target !== undefined)	str += ', ' + OEAnalyticsEventDataParamName.target + ' - ' + target;
            if(version !== undefined)	str += ', ' + OEAnalyticsEventDataParamName.version + ' - ' + version;
            str += '\n';
            console.log(str);
            if(eventData && typeof(eventData) === 'object') console.log(JSON.stringify(eventData) + '\n');
        }

        if(this.eventsEnabled)  OEAnalyticsTool.track(eventName, eventData, target, version);
    }

    //
    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.moduleId !== this.props.moduleId)  return true;
        return false;
    }

    componentDidMount() {
    }

    componentWillUnmount()    {
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiInstanceHelpViewEntryClicked, this.onHelpViewEntryClicked);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiInstanceHelpViewEntryClicked, this.onHelpViewEntryClicked);
    }

    updateState(released)   {
    }

    onHelpViewEntryClicked(message, userInfo)   {
        this.track(OEAnalyticsEventName.helpViewEntryClick, {[OEAnalyticsEventDataParamName.id]: userInfo.entryType, [OEAnalyticsEventDataParamName.desc]: this.props.target + ' - ' + userInfo.entryType});
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
            </React.Fragment>
        );
    }
}

OEAnalyticsTracker.defaultProps = {
    moduleId: ''
};

OEAnalyticsTracker.propTypes = {
    moduleId: PropTypes.string
};

export default frefFromRef(connectAppEnv((env) => { return {
    appComponent: env.component,
    target: env.config.target,
    version: env.config.version,
    appConfig: env.config
}})(frefToRef(OEAnalyticsTracker)));